<template>
  <div class="search-box pb24">
    <a-row :gutter="24">
      <a-col :span="8">
        <div class="flex flex_a">
          <span class="laber-span">关键字：</span>
          <a-input style="width: 260px" placeholder="请输入关键字" />
        </div>
      </a-col>
      <a-col :span="8">
        <a-button class="mr16" type="primary">查询</a-button>
        <a-button class="mr16">重置</a-button>
      </a-col>
    </a-row>
  </div>
</template>
<style lang="less" scoped>
.search-box {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.08);
  padding: 16px 24px;
  .laber-span{
    width: 70px;
  }
}
</style>